export enum SenderOptions {
  From = 1,
  ReplyTo = 2,
  Cc = 3,
  Bcc = 4
}
